import { default as ReactGA4 } from 'react-ga4';
import {
    LOG_URL,
    CONTENT_TYPE,
    SESSION_KEY,
    LSTORAGE_KEY,
    PLATFORM,
} from 'src/constants';
import {
    ArrayUtils,
    LocalStore,
    SessionStore,
    StringUtils,
    TimeUtils,
} from '.';
import { getGy, getVisitorID } from './cookie';
import { Logger } from './logger';
import { buildURLWithParam } from './common';

export const buildTrackingContent = (
    contentType: CONTENT_TYPE | undefined | string,
    tracking: string,
    index: number = 0,
) => {
    if (contentType === CONTENT_TYPE.AD_NATIVE) {
        return tracking;
    }

    return `${tracking}|index${index}`;
};

export const trackingPage = (
    key: string,
    value?: number,
    uid?: string,
    source?: string,
    extra: string = '',
    layout_type?: number,
) => {
    let _key = key;
    let _value = value;
    let _source: any;
    let _index: number = 0;
    let _push = false;

    const {
        utmSource = '',
        utmMedium = '',
        utmCampaign = '',
        utmTracking = '',
        sourceTracking = '',
    } = (window as any)._BM;

    if (utmTracking) {
        _key = `${utmSource}_${utmMedium}_${utmCampaign}:${_key}`;
        _push = (window as any).firstLoad;
    }

    if (key === 'mobile_article') {
        if (sourceTracking) {
            _source = sourceTracking.split('|index')[0];
            _index = +sourceTracking.split('|index')[1];

            if (sourceTracking.indexOf('search') > -1) {
                ReactGA4.event({
                    category: 'mobile_search',
                    action: 'clickItemSearch',
                });
            }
        }
        const data = LocalStore.get(LSTORAGE_KEY.VIEW_DETAIL) || {};
        const object = {
            [`${value}`]: {
                value: value,
                source: source || _source,
                uid: uid || LocalStore.get(LSTORAGE_KEY.BM_UID),
                index: _index,
                utmDirect: _push,
                layout_type: layout_type,
            },
        };
        const _data = ArrayUtils.mergeOverride(data, object);
        LocalStore.set(LSTORAGE_KEY.VIEW_DETAIL, _data);
    }

    const _data = Object.assign(
        {},
        (window as any).firstLoad
            ? {
                  ref: encodeURIComponent(document.referrer),
              }
            : {},
        {
            key: _key,
            value: _value,
            source: source || _source,
            uid: uid || LocalStore.get(LSTORAGE_KEY.BM_UID),
            index: _index,
            utmDirect: _push,
            layout_type: layout_type,
            ssid: getVisitorID()
                ? `${SessionStore.get(SESSION_KEY.SSID)}-${getVisitorID().slice(
                      -20,
                  )}`
                : '',
        },
        StringUtils.parse(extra),
    );

    let currentTime = TimeUtils.currentMilisecords();
    if (
        (window as any)._BM.logPageView &&
        (window as any)._BM.logPageView[key]
    ) {
        if (currentTime - (window as any)._BM.logPageView[key] > 1000) {
            fireTracking('/log', _data);
        }
    } else {
        fireTracking('/log', _data);
    }

    (window as any)._BM.logPageView = {
        ...(window as any)._BM.logPageView,
        [_key]: currentTime,
    };
};

export const trackingPageDetail = (
    value?: number,
    uid?: string,
    isOpen: boolean = false,
) => {
    setTimeout(() => {
        trackingPage('mobile_article', value, uid, '', '', isOpen ? 2 : 1);
        (window as any).firstLoad = false;
    }, 100);
};
export const trackingContent = (
    source: string,
    contentId: number,
    uid: string,
) => {
    if (!contentId || !source) {
        return;
    }
    const _data = {
        key: 'imps/mobiletrack/article',
        value: `${contentId}`,
        uid: uid || LocalStore.get(LSTORAGE_KEY.BM_UID),
        source: source.split('|index')[0],
        index: +source.split('|index')[1],
        ssid: getVisitorID()
            ? `${SessionStore.get(SESSION_KEY.SSID)}-${getVisitorID()?.slice(
                  -20,
              )}`
            : '',
    };

    let currentTime = TimeUtils.currentMilisecords();
    if (
        (window as any)._BM.logImps &&
        (window as any)._BM.logImps[
            `${source}-${contentId}-${getVisitorID()?.slice(0, 4)}`
        ]
    ) {
        return;
    } else {
        fireTracking('/imps', _data);
    }

    (window as any)._BM.logImps = {
        ...(window as any)._BM.logImps,
        [`${source}-${contentId}-${getVisitorID()?.slice(0, 4)}`]: currentTime,
    };
};

export const trackingContentDetail = (extData?: any) => {
    const totalSpendTime = extData?.sections?.filter(
        (item: any) => item.section === 'page',
    );
    const _data = {
        key: 'action_read_mobile_article',
        ssid: '',
        uid: LocalStore.get(LSTORAGE_KEY.BM_UID),

        total_spent_time: totalSpendTime?.[0]?.spent_time || 0,
    };

    fireTracking('/log', Object.assign({}, _data, extData));
};

export const trackingCampaign = (key: string, value: string) => {
    if (!key) {
        return;
    }
    const _data = {
        key: key,
        value: value,
    };

    fireTracking('/imps', _data);
};

export const trackingZShort = (
    shortId: number,
    source: string,
    uid: string,
    extra: string,
) => {
    if (!shortId) {
        return;
    }
    const _data = Object.assign(
        {},
        {
            key: 'imps/mobiletrack/zshort',
            value: `${shortId}`,
            uid: uid || LocalStore.get(LSTORAGE_KEY.BM_UID),
            source: source,
        },
        StringUtils.parse(extra),
    );

    fireTracking('/imps', _data);
};

export const trackingAdNative = (key: string) => {
    if (!key) {
        return;
    }

    const _data = {
        key,
        rand: Math.random(),
    };

    tracking(LOG_URL + '/imps', _data);
};

export const fireTracking = (type: string, data = {}) => {
    buildTrackingLog(type, data);
};

const buildTrackingLog = (type: string, data = {}) => {
    let _data;
    try {
        _data = window.btoa(
            StringUtils.stringify({
                rand: Math.random(),
                visitorId: getVisitorID(),
                gy: getGy(),
                ...data,
            }),
        );
    } catch (e) {
        Logger.error('tracking', 'fireTracking fail | ', e, 'type ', type);
    }

    if (_data) {
        tracking(LOG_URL + type, { data: _data });
    }
};

export function tracking(url: string, params: object) {
    const _url = buildURLWithParam(url, params);
    const img = document.createElement('img');

    setTimeout(() => {
        img.setAttribute('src', _url);
        img.setAttribute('style', 'display:none');
    }, 200);
}

export function formatTrackingUrl(url: string = '', tracking?: string): string {
    if (url) {
        return url.indexOf('#') > -1 ? url : url + '#' + tracking;
    }

    return '';
}

export function formatClickTrackingUrl(url: string): string {
    let result = url;
    const tracking = url.split('#')[1];
    const _tracking =
        tracking && tracking.indexOf('detail') < 0
            ? (window as any).pageType + tracking
            : tracking;
    result = url.split('#')[0] + '#' + _tracking;
    return result;
}

export function removeTrackingUrl(url: string): string {
    return url.split('#')[0];
}

export function srcImpsTracking(referrer: string): string {
    const test = /baomoi.com|dr.zapps.vn/i.test(referrer);
    const { utmSource } = (window as any)._BM;
    const fromZalo = utmSource === 'zalo';
    if (referrer && !test) {
        return `direct|${referrer.split('/')[2]}`;
    }
    if (fromZalo) {
        return `direct|zalo`;
    }
    return '';
}
